// Pagamento online cobrado pela Malga (MogoPay): só vale para os tipos de
// pagamento dedicados "MogoPay - PIX" (PMPY) e "MogoPay - Crédito" (CMPY).
// PIX/crédito próprios do estabelecimento são pagos na entrega/retirada, mesmo
// marcados como "Pagamento Online no Mogo Menu" — a exceção é o PIX com
// integrador na bandeira (ex.: Sicredi), que é cobrado pelo app mas pelo banco,
// não pela Malga.
export const PREFIXO_MOGOPAY_PIX = 'PMPY'
export const PREFIXO_MOGOPAY_CREDITO = 'CMPY'

const prefixoDe = (metodo) => (metodo?.Prefixo || '').trim().toUpperCase()

export const ehMogoPayPix = (metodo) => prefixoDe(metodo) === PREFIXO_MOGOPAY_PIX

export const ehMogoPayCredito = (metodo) => prefixoDe(metodo) === PREFIXO_MOGOPAY_CREDITO

export const ehMogoPay = (metodo) => ehMogoPayPix(metodo) || ehMogoPayCredito(metodo)

/** Cobrado pela Malga: exige a flag do Mogo Menu E um dos prefixos MogoPay. */
export const ehPagamentoMalga = (metodo) =>
  !!metodo?.PagamentoOnlineMogoMenu && ehMogoPay(metodo)

/** Bandeira com integrador PIX direto no banco (Sicredi). */
export const bandeiraSicredi = (metodo) =>
  metodo?.Bandeiras?.find((item) => item.Bandeira?.IntegradorPIX?.Banco == 'SICREDI')

/** PIX cobrado pelo app via integrador do banco — fora da Malga. */
export const ehPixIntegradorOnline = (metodo) =>
  prefixoDe(metodo) === 'PIX' &&
  !!metodo?.PagamentoOnlineMogoMenu &&
  !!bandeiraSicredi(metodo)

/** Qualquer forma cobrada na hora pelo app (Malga ou integrador PIX). */
export const ehPagamentoOnline = (metodo) =>
  ehPagamentoMalga(metodo) || ehPixIntegradorOnline(metodo)

/** PIX da aba "Pague pelo app": MogoPay tem prioridade sobre o integrador. */
export const buscaMetodoPixOnline = (metodos) =>
  (metodos || []).find((item) => ehPagamentoMalga(item) && ehMogoPayPix(item)) ||
  (metodos || []).find(ehPixIntegradorOnline)

/** Cartão de crédito da aba "Pague pelo app" (sempre Malga). */
export const buscaMetodoCreditoOnline = (metodos) =>
  (metodos || []).find((item) => ehPagamentoMalga(item) && ehMogoPayCredito(item))